import { DateTime, Icon } from '~/components';
import React, { useEffect, useState } from 'react';
import { usePopper } from 'react-popper';
import styled from 'styled-components';
import { colors } from '~/styles';
import { dateFormats } from '~/utils';
import { AllocationTooltip, Arrow } from './AllocationStyles';

const Row = styled.div`
  display: flex;
  justify-content: space-between;
`;

export default function DragTooltip({ start, end, updatePopperRef, referenceElement }) {
  const [popperElement, setPopperElement] = useState(null);
  const [arrowElement, setArrowElement] = useState(null);

  const { styles, attributes, update } = usePopper(referenceElement, popperElement, {
    modifiers: [
      { name: 'offset', options: { offset: [0, 8] } },
      { name: 'flip', options: { flipVariations: false } },
      { name: 'arrow', options: { element: arrowElement, padding: 5 } },
    ],
    placement: 'top',
  });

  useEffect(() => {
    updatePopperRef.current = update;

    return () => {
      updatePopperRef.current = null;
    };
  }, [updatePopperRef, update]);

  return (
    <AllocationTooltip ref={setPopperElement} style={styles.popper} {...attributes.popper}>
      <Row>
        <Icon icon="calendar" type="far" spaceRight color={colors.primary} />
        <DateTime value={start} format={dateFormats.standardDate} />
      </Row>

      <Row>
        <Icon icon="calendar" type="far" spaceRight color={colors.primary} />
        <DateTime value={end} format={dateFormats.standardDate} />
      </Row>

      <Arrow ref={setArrowElement} style={styles.arrow} />
    </AllocationTooltip>
  );
}
